import { render, staticRenderFns } from "./TransferRequests.vue?vue&type=template&id=2d673868"
import script from "./TransferRequests.vue?vue&type=script&lang=js"
export * from "./TransferRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports